import type { IChipInstanceModel } from '@/interfaces/models';
import type { ChipId } from '@/types/ids';

/** Break dependency cycles in a stable direction before expanding templates. */
export function isRecursiveBoundary(ownerId: ChipId, instance: IChipInstanceModel): boolean {
  if (instance.chipId === ownerId) return true;
  // Every directed cycle has an edge that increases its ID. Cutting only those
  // edges preserves the acyclic portion and gives the same result after reload.
  if (ownerId > instance.chipId) return false;
  return instance.chip?.recursiveChildChips.some(child => child.id === ownerId) ?? false;
}
